
import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

// Routes
import Routes from './routes';

// Material helpers
import { ThemeProvider } from '@material-ui/styles';

// Theme
import theme from 'theme';
// import "stylesheets/application-styles-mdr.css";
import "assets/scss/material-kit-pro-react.scss?v=1.3.0";
// Browser history
const browserHistory = createBrowserHistory();


export default class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router history={browserHistory}>
          <Routes />
        </Router>
      </ThemeProvider>
    );
  }
}
